import PageMetadata from './PageMetadata';

export default PageMetadata;
